define('plugin/product/view/ProductIndexView',['require','lib/view/LayoutView','plugin/product/view/ProductIndexListView','plugin/product/view/ProductCategoryListView','plugin/product/view/ProductIndexHeaderView','lib/pager/view/PagerView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var ProductIndexListView = require('plugin/product/view/ProductIndexListView');
    var ProductCategoryListView = require('plugin/product/view/ProductCategoryListView');
    var ProductIndexHeaderView = require('plugin/product/view/ProductIndexHeaderView');
    var PagerView = require('lib/pager/view/PagerView');

    /**
     * Product index view
     *
     * @class ProductIndexView
     */
    return LayoutView.extend({

        template: '#product_index_view',
        regions: {
            list: '#sb_list_container',
            pager: '#sb_pager_container',
            header: '#sb_header_container'
        },

        childEvents: {
            'buy': 'onBuyProduct',
            'open:cart': 'onOpenCart',
            'sort': 'onSortChange'
        },

        initialize: function () {
            LayoutView.prototype.initialize.call(this);

            this._categoryCollection = this.getOption('categoryCollection');
        },

        onBeforeShow: function() {
            this.showChildView('header', new ProductIndexHeaderView({
                categoryCollection: this._categoryCollection,
                category: this.getOption('category'),
                collection: this.getOption('collection'),
                sort: this.getOption('sort')
            }));

            if (this.getOption('step') == 'categories') {   
                this.showChildView('list', new ProductCategoryListView({
                    collection: this._categoryCollection
                }));

                //TODO check if pager must be removed
            } else {
                this.showChildView('list', new ProductIndexListView({
                    collection: this.getOption('collection'),
                    cart: this.getOption('cart'),
                }));
    
                if (this.getOption('collection').getPager) {
                    this.showChildView('pager', new PagerView({
                        pager: this.getOption('collection').getPager(),
                        url: this.getOption('url')
                    }));
                }
            }
        },

        onDomRefresh: function () {
            if (this.getOption('step') == 'products') {
                Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                    'page': 'products_catalog'
                });
            }
        },

        onBuyProduct: function (view, id, qty) {
            this.triggerMethod('buy', id, qty);
        },

        onSortChange: function (view, sort) {
            this.triggerMethod('sort', sort);
        },

        onOpenCart: function (view) {
            console.log(this.getOption('cart'));
            this.getOption('cart').trigger('toggle:popup');
            // this.triggerMethod('open:cart');
        },

    });

});
